import React from "react";
import {
    MantineReactTable,
    useMantineReactTable,
} from "mantine-react-table";
import { Button, Box } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const CommonTable = ({
    columns,
    data,
    fileName = "export-data",
    showSelection = true,
}) => {
    const handleExportRows = (rows) => {
        const doc = new jsPDF();

        const tableHeaders = columns.map((c) => c.header);
        const tableData = rows.map((row) =>
            columns.map((col) => row.original[col.accessorKey] ?? "")
        );

        autoTable(doc, {
            head: [tableHeaders],
            body: tableData,
        });

        doc.save(`${fileName}.pdf`);
    };

    const table = useMantineReactTable({
        columns,
        data,

        layoutMode: "grid",
        enableColumnResizing: true,
        enableStickyHeader: true,
        enableRowSelection: showSelection,

        mantineTableContainerProps: {
            style: {
                maxHeight: "650px",
            },
        },

        mantineTableHeadCellProps: {
            style: {
                padding: "12px 16px",
                fontSize: "14px",
                fontWeight: 600,
            },
        },

        mantineTableBodyCellProps: {
            style: {
                padding: "12px 16px",
                fontSize: "14px",
            },
        },

        initialState: {
            pagination: { pageSize: 10 },
            density: "md", // ✅ Balanced spacing
            columnPinning: { right: ["Actions"] },
        },

        renderTopToolbarCustomActions: ({ table }) => (
            <Box style={{ display: "flex", gap: "12px", padding: "6px" }}>
                <Button
                    variant="light"
                    leftSection={<IconDownload size={16} />}
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                >
                    Export Page
                </Button>

                {showSelection && (
                    <Button
                        variant="outline"
                        disabled={!table.getIsSomeRowsSelected()}
                        onClick={() =>
                            handleExportRows(table.getSelectedRowModel().rows)
                        }
                    >
                        Export Selected
                    </Button>
                )}
            </Box>
        ),
    });

    return <MantineReactTable table={table} />;
};

export default CommonTable;